import React, { useEffect, useState } from "react";
import SingleLabel from "./SingleLabel";

const worker = new Worker("/workers/generateQr.js");

export default function PrintLabels({
  billingDetails,
  organisation,
  selectedRoutes,
  solution,
  data
}) {
  if (!data) {
    data = [
      ...solution.routes.reduce((array, route) => {
        return [
          ...array,
          ...(!selectedRoutes.length || selectedRoutes.includes(route.id)
            ? route.stops
                .filter(task => !["start", "end", "break"].includes(task.type))
                .reduce((array, row) => {
                  return [
                    ...array,
                    ...(!row.units || row.units.length === 0
                      ? [{ ...row, units: [] }]
                      : row.units.map((unit, i) => ({
                          ...row,
                          units: [unit]
                        })))
                  ];
                }, [])
            : [])
        ];
      }, []),
      ...(!selectedRoutes.length
        ? solution.unassigned.stops.reduce((array, row) => {
            return [
              ...array,
              ...(!row.units || row.units.length === 0
                ? [{ ...row, units: [] }]
                : row.units.map((unit, i) => ({
                    ...row,
                    units: [unit]
                  })))
            ];
          }, [])
        : [])
    ];
  }

  useEffect(() => {
    worker.postMessage({ d: data });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [qrSVGs, setQrSVGs] = useState([]);

  worker.onmessage = msg => {
    setQrSVGs(msg.data.response);
  };

  return (
    <>
      {!!qrSVGs.length &&
        data.map((stop, i) => {
          return (
            <SingleLabel
              key={i}
              stop={stop}
              qrSvg={qrSVGs[i]}
              billingDetails={billingDetails}
              organisation={organisation}
            />
          );
        })}
    </>
  );
}
